export default __webpack_public_path__ + "static/flutter-228ce64c36337b1c67b614a2aef32316.svg";